"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { SortDirection } from "@/entities/ISort";
import { RepsTableSort } from "./UserPageRepRepsTable";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
export default function UserPageRepRepsTableHeaderSortableCell(t0) {
  const $ = _c(23);
  const {
    type,
    activeType,
    activeDirection,
    onSortTypeClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [RepsTableSort.REP]: "Rep",
      [RepsTableSort.RATERS]: "Raters",
      [RepsTableSort.MY_RATES]: "My Rates"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const SORT_TYPE_TO_TEXT = t1;
  const [isActive, setIsActive] = useState(type === activeType);
  let t2;
  if ($[1] !== activeType || $[2] !== type) {
    t2 = () => {
      setIsActive(type === activeType);
    };
    $[1] = activeType;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeType) {
    t3 = [activeType];
    $[4] = activeType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  const [sor, setSor] = useState(isActive ? activeDirection : SortDirection.DESC);
  let t4;
  let t5;
  if ($[6] !== activeDirection || $[7] !== isActive) {
    t4 = () => {
      setSor(isActive ? activeDirection : SortDirection.DESC);
    };
    t5 = [activeDirection, isActive];
    $[6] = activeDirection;
    $[7] = isActive;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== onSortTypeClick || $[11] !== type) {
    t6 = () => onSortTypeClick(type);
    $[10] = onSortTypeClick;
    $[11] = type;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `${isActive ? "tw-text-primary-400" : "group-hover:tw-text-iron-200"} tw-transition tw-duration-300 tw-ease-out`;
  const t8 = SORT_TYPE_TO_TEXT[type];
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <span className={t7}>{t8}</span>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isActive || $[17] !== sor) {
    t10 = <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={sor} isActive={isActive} /></span>;
    $[16] = isActive;
    $[17] = sor;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6 || $[21] !== t9) {
    t11 = <th scope="col" className="tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-cursor-pointer tw-py-3 tw-text-right tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400" onClick={t6}>{t9}{t10}</th>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}